const HTML_TAG_RE = /<[a-z][^>]*>/i;

export const joinChunks = (
  chunks: Array<{ message: string }>,
  replaceNewlines?: boolean
) => {
  if (!chunks?.length) return "";
  const joined = chunks.map((chunk) => chunk.message).join("");
  const shouldReplace = replaceNewlines ?? !HTML_TAG_RE.test(joined);
  return shouldReplace ? joined.replaceAll("\n", "<br/>") : joined;
};
